/**
 * NotesIcon — Persistent icon button in the Ask AI header.
 * Shows a badge with the count of tabs that have content.
 * Clicking opens the full-screen NotesWindow.
 */
import React from 'react';
import { IconButton, Tooltip, Badge } from '@mui/material';
import { MenuBook } from '@mui/icons-material';

export default function NotesIcon({ badge = 0, onClick }) {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('[NotesIcon] Opening modal');
        if (onClick) onClick(e);
    };

    return (
        <Tooltip title="Research Notes (Ctrl+N)" arrow>
            <IconButton
                size="small"
                onClick={handleClick}
                type="button"
                sx={{
                    color: badge > 0 ? 'var(--brand)' : 'var(--text-2)',
                    '&:hover': { color: 'var(--brand)', backgroundColor: 'var(--bg-3)' },
                    borderRadius: 1,
                    width: 32,
                    height: 32,
                }}
            >
                <Badge
                    badgeContent={badge}
                    max={9}
                    sx={{
                        '& .MuiBadge-badge': {
                            fontSize: '0.6rem',
                            height: 14,
                            minWidth: 14,
                            backgroundColor: 'var(--brand)',
                            color: '#070B12',
                            fontWeight: 700,
                        },
                    }}
                >
                    <MenuBook sx={{ fontSize: 18 }} />
                </Badge>
            </IconButton>
        </Tooltip>
    );
}
